import FloodlightActivities from "@/pixels/providers/floodlightActivities";

describe("FloodlightActivities config", () => {
  beforeEach(() => {
    jest.spyOn(FloodlightActivities, "enable");
    jest.spyOn(FloodlightActivities, "init");
    jest.spyOn(FloodlightActivities, "wait");
    jest.spyOn(FloodlightActivities, "landing");
    jest.spyOn(FloodlightActivities, "oferta");
    jest.spyOn(FloodlightActivities, "ofertaCA");
    jest.spyOn(FloodlightActivities, "sucursal");
    jest.spyOn(FloodlightActivities, "paso1");
    jest.spyOn(FloodlightActivities, "paso2");
    jest.spyOn(FloodlightActivities, "paso3");
    jest.spyOn(FloodlightActivities, "paso4");
    jest.spyOn(FloodlightActivities, "thankYou");
    jest.spyOn(FloodlightActivities, "thankYouCA");
    jest.spyOn(FloodlightActivities, "cliente");

    window.gtag = jest.fn();
  });

  it("configuracion FloodlightActivities por defecto", () => {
    const context = {
      state: {
        dataOferta: {
          oferta: {}
        }
      }
    };

    FloodlightActivities.enable();
    FloodlightActivities.init();
    FloodlightActivities.wait();
    FloodlightActivities.landing();
    FloodlightActivities.oferta();
    FloodlightActivities.ofertaCA();
    FloodlightActivities.sucursal();
    FloodlightActivities.paso1();
    FloodlightActivities.paso2();
    FloodlightActivities.paso3();
    FloodlightActivities.paso4();
    FloodlightActivities.thankYou(context);
    FloodlightActivities.thankYouCA(context);
    FloodlightActivities.cliente(context);

    const enableMock = jest.spyOn(FloodlightActivities, "enable");
    const initMock = jest.spyOn(FloodlightActivities, "init");
    const waitMock = jest.spyOn(FloodlightActivities, "wait");
    const landingMock = jest.spyOn(FloodlightActivities, "landing");
    const ofertaMock = jest.spyOn(FloodlightActivities, "oferta");
    const ofertaCAMock = jest.spyOn(FloodlightActivities, "ofertaCA");
    const sucursalMock = jest.spyOn(FloodlightActivities, "sucursal");
    const paso1Mock = jest.spyOn(FloodlightActivities, "paso1");
    const paso2Mock = jest.spyOn(FloodlightActivities, "paso2");
    const paso3Mock = jest.spyOn(FloodlightActivities, "paso3");
    const paso4Mock = jest.spyOn(FloodlightActivities, "paso4");
    const thankYouMock = jest.spyOn(FloodlightActivities, "thankYou");
    const thankYouCAMock = jest.spyOn(FloodlightActivities, "thankYouCA");
    const clienteMock = jest.spyOn(FloodlightActivities, "cliente");

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(initMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(landingMock).toHaveBeenCalledTimes(1);
    expect(ofertaMock).toHaveBeenCalledTimes(1);
    expect(ofertaCAMock).toHaveBeenCalledTimes(1);
    expect(sucursalMock).toHaveBeenCalledTimes(1);
    expect(paso1Mock).toHaveBeenCalledTimes(1);
    expect(paso2Mock).toHaveBeenCalledTimes(1);
    expect(paso3Mock).toHaveBeenCalledTimes(1);
    expect(paso4Mock).toHaveBeenCalledTimes(1);
    expect(thankYouMock).toHaveBeenCalledTimes(1);
    expect(thankYouCAMock).toHaveBeenCalledTimes(1);
    expect(clienteMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion exportada por defecto", () => {
    expect(FloodlightActivities).toBeDefined();
    expect(FloodlightActivities).not.toBeNull();
    expect(typeof FloodlightActivities).toBe("object");
  });
});
